<script lang="ts">
    function handlePrint() {
        window.print();
    }
</script>

<section class="reportToolbar">
    <img src="/assets/logo.png" alt="">
    <!-- <img src="/assets/icons/dashboard.png" alt=""> -->
    <img on:click={handlePrint} src="/assets/icons/printer.png" alt="">
</section>

<style lang="scss">
    .reportToolbar {
        position: fixed;
        bottom: 1rem;
        right: 1rem;

        @media print {
            display: none;
        }

        img {
            width: 64px;
            margin-right: .5rem;
            cursor: pointer;
        }
    }
</style>